import { iFrame } from './types/Iframe';
import { IframeSC } from './styles/index';

export const Iframe = ({ url, title }: iFrame): JSX.Element => {
  return <IframeSC src={url} title={title} />;
};
